export const revolutuinaryData = {
  "Нур-султан": {
    "Управление 1123123123": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
  },
  Алмата: {
    "Управление 1": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
    "Управление 2": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 2": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 3": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
    "Управление 3": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 2": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 3": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
  },
  Актау: {
    "Управление 1": {
      "Отдел 1": {
        "Команда 1": {
          "Отдел 1": {
            "Команда 1": {
              "Общее количество": 120,
              "Фактическое количество": 64,
            },
            "Команда 2": {
              "Общее количество": 45,
              "Фактическое количество": 2,
            },
          },
          "Отдел 2": {
            "Команда 1": {
              "Отдел 1": {
                "Команда 1": {
                  "Отдел 1": {
                    "Команда 1": {
                      "Отдел 1": {
                        "Команда 1": {
                          "Отдел 1": {
                            "Команда 1": {
                              "Общее количество": 120,
                              "Фактическое количество": 64,
                            },
                            "Команда 2": {
                              "Общее количество": 45,
                              "Фактическое количество": 2,
                            },
                          },
                        },
                        "Команда 2": {
                          "Общее количество": 45,
                          "Фактическое количество": 2,
                        },
                      },
                    },
                    "Команда 2": {
                      "Общее количество": 45,
                      "Фактическое количество": 2,
                    },
                  },
                },
                "Команда 2": {
                  "Общее количество": 45,
                  "Фактическое количество": 2,
                },
                "Отдел 2": {
                  "Команда 1": {
                    "Общее количество": 120,
                    "Фактическое количество": 64,
                  },
                  "Команда 2": {
                    "Общее количество": 45,
                    "Фактическое количество": 2,
                  },
                },
                "Отдел 3": {
                  "Команда 1": {
                    "Общее количество": 120,
                    "Фактическое количество": 64,
                  },
                  "Команда 2": {
                    "Общее количество": 45,
                    "Фактическое количество": 2,
                  },
                },
              },
            },
            "Команда 2": {
              "Общее количество": 45,
              "Фактическое количество": 2,
            },
          },
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
    "Управление 2": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 2": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 3": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
    "Управление 3": {
      "Отдел 1": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 2": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
      "Отдел 3": {
        "Команда 1": {
          "Общее количество": 120,
          "Фактическое количество": 64,
        },
        "Команда 2": {
          "Общее количество": 45,
          "Фактическое количество": 2,
        },
      },
    },
  },
};
export const data = {
  "Нур-султан": {
    Подразделения: {
      "Управление 1123123123": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 120,
                  "Фактическое количество": 64,
                },
              },
              "Команда 2": {
                Данные: {
                  "Общее количество": 45,
                  "Фактическое количество": 2,
                },
              },
            },
          },
          "Отдел 2": {
            Подразделения: {
              "Управление 1": {
                Подразделения: {
                  "Отдел 1": {
                    Подразделения: {
                      "Команда 1": {
                        Данные: {
                          "Общее количество": 10,
                          "Фактическое количество": 10,
                        },
                      },
                      "Команда 2": {
                        Данные: {
                          "Общее количество": 100,
                          "Фактическое количество": 150,
                        },
                      },
                    },
                  },
                  "Отдел 2": {
                    Данные: {
                      "Общее количество": 21,
                      "Фактическое количество": 11,
                    },
                  },
                },
              },
              "Управление 2": {
                Подразделения: {
                  "Отдел 1": {
                    Подразделения: {
                      "Команда 1": {
                        Данные: {
                          "Общее количество": 10,
                          "Фактическое количество": 10,
                        },
                      },
                      "Команда 2": {
                        Подразделения: {
                          "Управление 1": {
                            Подразделения: {
                              "Отдел 1": {
                                Подразделения: {
                                  "Команда 1": {
                                    Данные: {
                                      "Общее количество": 10,
                                      "Фактическое количество": 10,
                                    },
                                  },
                                  "Команда 2": {
                                    Данные: {
                                      "Общее количество": 100,
                                      "Фактическое количество": 150,
                                    },
                                  },
                                },
                              },
                              "Отдел 2": {
                                Данные: {
                                  "Общее количество": 21,
                                  "Фактическое количество": 11,
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  "Отдел 2": {
                    Данные: {
                      "Общее количество": 21,
                      "Фактическое количество": 11,
                    },
                  },
                },
              },
            },
          },
        },
      },
      "Управление 2": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 4,
                  "Фактическое количество": 2,
                },
              },
              "Команда 2": {
                Подразделения: {
                  "Управление 1": {
                    Подразделения: {
                      "Отдел 1": {
                        Подразделения: {
                          "Команда 1": {
                            Данные: {
                              "Общее количество": 1,
                              "Фактическое количество": 0,
                            },
                          },
                          "Команда 2": {
                            Данные: {
                              "Общее количество": 563,
                              "Фактическое количество": 645,
                            },
                          },
                        },
                      },
                      "Отдел 2": {
                        Данные: {
                          "Общее количество": 234,
                          "Фактическое количество": 6,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          "Отдел 2": {
            Данные: {
              "Общее количество": 21,
              "Фактическое количество": 11,
            },
          },
        },
      },
    },
  },
  Алматы: {
    Подразделения: {
      "Управление 1": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 10,
                  "Фактическое количество": 10,
                },
              },
              "Команда 2": {
                Данные: {
                  "Общее количество": 100,
                  "Фактическое количество": 150,
                },
              },
            },
          },
          "Отдел 2": {
            Данные: {
              "Общее количество": 21,
              "Фактическое количество": 11,
            },
          },
        },
      },
      "Управление 2": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 10,
                  "Фактическое количество": 10,
                },
              },
              "Команда 2": {
                Подразделения: {
                  "Управление 1": {
                    Подразделения: {
                      "Отдел 1": {
                        Подразделения: {
                          "Команда 1": {
                            Данные: {
                              "Общее количество": 10,
                              "Фактическое количество": 10,
                            },
                          },
                          "Команда 2": {
                            Данные: {
                              "Общее количество": 100,
                              "Фактическое количество": 150,
                            },
                          },
                        },
                      },
                      "Отдел 2": {
                        Данные: {
                          "Общее количество": 21,
                          "Фактическое количество": 11,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          "Отдел 2": {
            Данные: {
              "Общее количество": 21,
              "Фактическое количество": 11,
            },
          },
        },
      },
    },
  },
  Актау: {
    Подразделения: {
      "Управление 1": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 120,
                  "Фактическое количество": 64,
                },
              },
              "Команда 2": {
                Данные: {
                  "Общее количество": 45,
                  "Фактическое количество": 2,
                },
              },
            },
          },
          "Отдел 2": {
            Данные: {
              "Общее количество": 54,
              "Фактическое количество": 7,
            },
          },
        },
      },
      "Управление 2": {
        Подразделения: {
          "Отдел 1": {
            Подразделения: {
              "Команда 1": {
                Данные: {
                  "Общее количество": 4,
                  "Фактическое количество": 2,
                },
              },
              "Команда 2": {
                Подразделения: {
                  "Управление 1": {
                    Подразделения: {
                      "Отдел 1": {
                        Подразделения: {
                          "Команда 1": {
                            Данные: {
                              "Общее количество": 1,
                              "Фактическое количество": 0,
                            },
                          },
                          "Команда 2": {
                            Данные: {
                              "Общее количество": 563,
                              "Фактическое количество": 645,
                            },
                          },
                        },
                      },
                      "Отдел 2": {
                        Данные: {
                          "Общее количество": 234,
                          "Фактическое количество": 6,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          "Отдел 2": {
            Данные: {
              "Общее количество": 21,
              "Фактическое количество": 11,
            },
          },
        },
      },
    },
  },
};

export const oldData = {
  "Нур-султан": {
    "Центр 1": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
  },
  Актау: {
    "Центр 1": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 2": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 3": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 4": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 5": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 6": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 7": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 8": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
    "Центр 9": {
      "Управление 1": {
        "Отдел 1": {
          "Вложение 1": {
            "Вложение 1.1": {
              "Общее количество": 10,
              "Фактическое количество": 12,
            },
          },
          "Вложение 2": {
            "Вложение 2.1": {
              "Общее количество": 31,
              "Фактическое количество": 29,
            },
          },
          "Вложение 3": {
            "Вложение 3.1": {
              "Вложение 3.1.1": {
                "Вложение 3.1.1.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
              },
              "Вложение 3.1.2": {
                "Вложение 3.1.2.1": {
                  "Общее количество": 31,
                  "Фактическое количество": 29,
                },
                "Вложение 3.1.2.2": {
                  "Общее количество": 32,
                  "Фактическое количество": 29,
                },
              },
            },
          },
        },
      },
    },
  },
};
